import BackdropInitialDemo from './BackdropInitialDemo';
import BasicBlur from './BasicBlur';
import BlurryText from './BlurryText';
import EquationMaskIntro from './EquationMaskIntro';
import EquationMaskReal from './EquationMaskReal';
import GlassyEdge from './GlassyEdge';
import HueRotate from './HueRotate';
import LeavingTheTop from './LeavingTheTop';
import MainUseCaseDemo from './MainUseCaseDemo';
import TheProblem from './TheProblem';
import TooBusy from './TooBusy';

const MAP = {
  BackdropInitialDemo,
  BasicBlur,
  BlurryText,
  EquationMaskIntro,
  EquationMaskReal,
  GlassyEdge,
  HueRotate,
  LeavingTheTop,
  MainUseCaseDemo,
  TheProblem,
  TooBusy,
};

interface Props {
  variant: keyof typeof MAP;
}

export default function BackdropFilterDemo({
  variant,
  ...delegated
}: Props) {
  const Component = MAP[variant];

  if (!Component) {
    throw new Error(`Unrecognized variant: ${variant}`);
  }

  // @ts-ignore
  return <Component {...(delegated || {})} />;
}
